import { createStoreChunk } from '@core/store'
import type { TGreetingKey } from '../constants/greetings'

export type TAuthView = 'sign-in' | 'sign-up' | 'forgot-password'

/**
 * Auth-modal view + contextual greeting. `core/modal` only tracks *which* dialog is open; this holds
 * the auth-specific data (mirror of `giftStore`). `greetingKey` is a serializable replacement for
 * audio-web's `customSignInGreeting: ElementType` — the container maps it to `{ title, subtitle }`.
 */

type TAuthModalState = {
    activeView: TAuthView
    entryView: TAuthView
    greetingKey: TGreetingKey
    modalType: string | null
    isAuthSuccessful: boolean
}

export const authModalStore = createStoreChunk<TAuthModalState>('authModal')({
    initialState: {
        activeView: 'sign-in',
        entryView: 'sign-in',
        greetingKey: 'default',
        modalType: null,
        isAuthSuccessful: false,
    },
})
